import {
  Step,
  StepDownstream,
  StepId,
} from "@redotech/redo-return-ui/flows/step";
import { Edge, MarkerType } from "@xyflow/react";
import { MutableRefObject } from "react";

export function createEdgesFromSteps(
  steps: Map<StepId, Step>,
  nodePositions: Map<string, { x: number; y: number }>,
  selectedNodeIdsRef: MutableRefObject<Set<string>>,
  validNodeIds: Set<string>,
): Edge[] {
  const finalEdges: Edge[] = [];

  for (const [stepId, step] of steps) {
    const downstreams = step.downstream();
    if (downstreams.length === 0) {
      continue;
    }

    const sourcePosition = nodePositions.get(stepId);
    if (!sourcePosition) {
      continue;
    }

    if (!validNodeIds.has(stepId)) {
      continue;
    }

    const downstreamsWithIndices = downstreams.map(
      (downstream: StepDownstream, originalIndex: number) => ({
        downstream,
        originalIndex,
      }),
    );

    const validDownstreams = downstreamsWithIndices.filter(
      (
        item,
      ): item is {
        downstream: StepDownstream & { id: string };
        originalIndex: number;
      } =>
        item.downstream.id !== undefined &&
        steps.has(item.downstream.id) &&
        validNodeIds.has(item.downstream.id),
    );

    for (const { downstream, originalIndex } of validDownstreams) {
      const shouldBeSelected =
        selectedNodeIdsRef.current.has(stepId) &&
        selectedNodeIdsRef.current.has(downstream.id);

      finalEdges.push({
        id: `${stepId}-${downstream.id}-${originalIndex}`,
        source: stepId,
        sourceHandle: `${stepId}-${downstream.id}-${originalIndex}`,
        target: downstream.id,
        targetHandle: null,
        label: downstream.label,
        type: "customFlow",
        style: { stroke: "black", strokeWidth: 1 },
        markerEnd: { type: MarkerType.Arrow, color: "black" },
        data: { edgeIndex: originalIndex, totalEdges: validDownstreams.length },
        selected: shouldBeSelected,
      });
    }
  }

  return finalEdges;
}
